import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import BusinessesView from '../views/BusinessesView.vue'
import BusinessDetailView from '../views/BusinessDetailView.vue'
import LicensesView from '../views/LicensesView.vue'
import PaymentsView from '../views/PaymentsView.vue'
import MusicLibraryView from '../views/MusicLibraryView.vue'
import WhatsAppAdminView from '../views/WhatsAppAdminView.vue'
import HSNRatesView from '../views/HSNRatesView.vue'
import AutomationsView from '../views/automation/AutomationsView.vue'
import AutomationEditor from '../views/automation/AutomationEditor.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/businesses',
    name: 'businesses',
    component: BusinessesView,
    meta: { requiresAuth: true },
  },
  {
    path: '/businesses/:id',
    name: 'business-detail',
    component: BusinessDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: '/licenses',
    name: 'licenses',
    component: LicensesView,
    meta: { requiresAuth: true },
  },
  {
    path: '/payments',
    name: 'payments',
    component: PaymentsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/music-library',
    name: 'music-library',
    component: MusicLibraryView,
    meta: { requiresAuth: true },
  },
  {
    path: '/whatsapp',
    name: 'whatsapp-admin',
    component: WhatsAppAdminView,
    meta: { requiresAuth: true },
  },
  {
    path: '/hsn-rates',
    name: 'hsn-rates',
    component: HSNRatesView,
    meta: { requiresAuth: true },
  },
  {
    path: '/automations',
    name: 'automations',
    component: AutomationsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/automations/:id/edit',
    name: 'automation-editor',
    component: AutomationEditor,
    meta: { requiresAuth: true },
  },
]

export default routes
